import { SELECTED_ORDER } from 'modules/arena/dashboard/content';
import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { useToast } from 'shared/components/ui/Toast';

const STATUS_LABEL = {
  paid: { text: 'pago', className: 'text-success' },
  pending: { text: 'pendente', className: 'text-warning' },
  empty: { text: 'sem convite', className: 'text-ink-secondary/60' },
};

export function SelectedOrderPanel() {
  const toast = useToast();
  const pendingNames = SELECTED_ORDER.quotas.filter((quota) => quota.status === 'pending').map((quota) => quota.name);

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Pedido selecionado</h3>
        <span className="text-xs text-ink-secondary">{SELECTED_ORDER.id}</span>
      </div>

      <p className="mt-1 text-sm font-medium text-ink">{SELECTED_ORDER.courtLabel}</p>
      <p className="text-xs text-warning">{SELECTED_ORDER.expiresLabel}</p>

      <div className="mt-4 divide-y divide-border/70">
        {SELECTED_ORDER.quotas.map((quota) => (
          <div key={quota.name} className="flex items-center justify-between py-2 text-sm">
            <span className="text-ink">{quota.name}</span>
            <span className={STATUS_LABEL[quota.status].className}>
              {quota.status === 'empty' ? quota.methodLabel : `${quota.methodLabel} · ${STATUS_LABEL[quota.status].text}`}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-4 flex gap-2">
        <Button
          variant="ghost"
          className="flex-1"
          onClick={() =>
            toast({ title: 'Prazo estendido em 30 min', description: 'Os participantes com cota pendente foram avisados.' })
          }
        >
          Estender prazo
        </Button>
        <Button
          className="flex-1"
          onClick={() =>
            toast({
              title: 'Cobrança enviada',
              description:
                pendingNames.length === 1
                  ? `${pendingNames[0]} recebeu o link de pagamento da cota.`
                  : `${pendingNames.join(', ') || 'Os participantes'} receberam o link de pagamento das cotas.`,
            })
          }
        >
          Cobrar restante
        </Button>
      </div>
    </Card>
  );
}
